import JetFMContext, { FMSource } from '../components/JetFMWrapper/JetFMProvider';
import { useContext } from 'react';
import { IJetFMFeature } from '../models';

const useFMFeatureFlag = (featureConfig: IJetFMFeature, source: FMSource = 'MCP') => {
  const { featureName, featureDataType, valueUntilFMReady } = featureConfig;
  const { featureManagement } = useContext(JetFMContext);
  const fm = featureManagement[source];
  const valueGetterFunctionName = `get${featureDataType}Value`;

  if (fm) {
    const getterFunction = (fm as Record<string, Function>)[valueGetterFunctionName];
    return getterFunction.call(fm, featureName);
  }

  return valueUntilFMReady;
};

export default useFMFeatureFlag;
